/**
 * How a property's label reads back to a person. A label defaults to its token
 * name, and token names are PascalCase because that is what `{{SecondPartyAddress}}`
 * needs — unreadable as a form label, so the words are split back apart.
 *
 * Pure and i18n-free. Labels an author has already written out are left alone:
 * the splits only fire at a case boundary, which spaced text does not have.
 */

/** `SecondPartyAddress` → `Second Party Address`; `NDAStartDate` → `NDA Start Date`. */
export function fieldLabel(label: string): string {
  return label
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
}
